import { dfApi as api } from '@services/df/baseApi';
const injectedRtkApi = api.injectEndpoints({
    endpoints: build => ({
        usersWidgetTechnologiesList: build.query<
            UsersWidgetTechnologiesListApiResponse,
            UsersWidgetTechnologiesListApiArg
        >({
            query: queryArg => ({
                url: `/v2/users/widget-technologies/`,
                params: { limit: queryArg.limit, offset: queryArg.offset },
            }),
        }),
        widgetTechnologiesList: build.query<WidgetTechnologiesListApiResponse, WidgetTechnologiesListApiArg>({
            query: queryArg => ({
                url: `/v2/widget-technologies/`,
                params: { limit: queryArg.limit, offset: queryArg.offset },
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type UsersWidgetTechnologiesListApiResponse = /** status 200  */ PaginatedWidgetTechnologyList;
export type UsersWidgetTechnologiesListApiArg = {
    /** Number of results to return per page. */
    limit?: number;
    /** The initial index from which to return the results. */
    offset?: number;
};
export type WidgetTechnologiesListApiResponse = /** status 200  */ PaginatedWidgetTechnologyList;
export type WidgetTechnologiesListApiArg = {
    /** Number of results to return per page. */
    limit?: number;
    /** The initial index from which to return the results. */
    offset?: number;
};
export type ExtraFieldOption = {
    id: string;
    option: string;
};
export type ExtraFieldSet = {
    id: string;
    title?: string;
    options: ExtraFieldOption[];
    is_active?: boolean;
    sort_order?: number;
    material?: number | null;
};
export type ExecutionTypeEnum = 'layer_thickness' | 'filling' | 'color';
export type Color = {
    id: string;
    color: string;
    label: string;
};
export type Execution = {
    id?: string;
    option?: number | null;
    execution_type: ExecutionTypeEnum;
    name_for_user?: string;
    note_for_user?: string;
    colors?: Color[];
    sort_order?: number;
    display_name: string;
};
export type FormTypeEnum = 'post_production_default' | 'post_production_coloring';
export type PriceUnitsEnum = 'per_model' | 'per_cm_2' | 'per_cm_3' | 'per_bb';
export type BlankEnum = '';
export type NullEnum = null;
export type PostProduction = {
    id?: string;
    title?: string;
    active?: boolean;
    form_type?: FormTypeEnum;
    is_custom?: boolean | null;
    price?: number | null;
    price_units?: (PriceUnitsEnum | BlankEnum | NullEnum) | null;
    minimal_price?: number | null;
    /**
            Minimal price is applied within line item count if enabled, otherwise it is applied within post-production count
             */
    minimal_within_line_item?: boolean;
    /** Multiplier for naked price (0 means no multiplier) */
    price_multiplier?: number;
    setup_cost?: number | null;
    production_days?: number;
    name_for_user?: string;
    note_for_user?: string;
    group_title?: string;
    countable?: boolean;
    manual_review?: boolean;
    colors?: Color[];
    sort_order?: number;
    is_exclusive?: boolean | null;
};
export type Tolerance = {
    id?: string;
    deviation_from?: number;
    deviation_to?: number;
    margin?: number;
    name_for_user?: string;
    sort_order?: number;
    display_name?: string;
};
export type Priority = {
    id?: string;
    days?: number;
    factor?: number;
    name_for_user?: string;
    note_for_user?: string;
    sort_order?: number;
    tbd_quantity_threshold?: number;
    display_name: string;
};
export type FeatureTypeEnum = 'cuboids' | 'axial' | 'eccentric' | 'radial' | 'single_step_reduction';
export type ShapeTypeEnum = 'simple' | 'countersunk' | 'counterdrilled' | 'counterbored' | 'general';
export type ThroughEnum = 'through' | 'not_through';
export type TopologyTypeEnum = 'hole' | 'slot' | 'pocket' | 'notch' | 'reduction';
export type Feature = {
    id?: string;
    name: string;
    price_set_up?: number;
    price_per_feature?: number;
    feature_type?: FeatureTypeEnum | BlankEnum;
    shape_type?: ShapeTypeEnum | BlankEnum;
    /** Is this feature allowed to be through
    
    * `` - Allow both
    * `through` - Through-only
    * `not_through` - Not through-only */
    through?: ThroughEnum | BlankEnum;
    /** Min ratio (need to be >=) of height to diameter */
    min_ratio?: number;
    /** Max ratio (need to be <) of height to diameter */
    max_ratio?: number;
    is_active?: boolean;
    time_per_feature?: number;
    time_of_programming_recurring?: number;
    time_of_programming_non_recurring?: number;
    /** Min endwall radius (need to be >=) */
    radius?: number;
    /** Max vertical angle, (need to be <=) */
    angle?: number;
    topology_type?: TopologyTypeEnum | BlankEnum;
};
export type BarstockThickness = {
    id: string;
    thickness: number;
    client_notes?: string;
};
export type TechnologyMaterial = {
    id: number;
    title: string;
    sorting_priority?: number;
    note_for_user?: string;
    spec_sheet_url?: string;
    printer_size: string;
    min_wall_thickness: number;
    accept_drawing: string;
    is_iqt_only: boolean;
    extra_fieldsets: ExtraFieldSet[];
    tags?: string[];
    executions: Execution[];
    post_production: PostProduction[];
    tolerance: Tolerance[];
    lead_time: Priority[];
    dfm_features: Feature[];
    thicknesses: BarstockThickness[];
};
export type WidgetTechnology = {
    id: number;
    title: string;
    tech_id: number;
    note: string;
    image: string;
    materials: TechnologyMaterial[];
};
export type PaginatedWidgetTechnologyList = {
    count: number;
    next?: string | null;
    previous?: string | null;
    results: WidgetTechnology[];
};
export const { useUsersWidgetTechnologiesListQuery, useWidgetTechnologiesListQuery } = injectedRtkApi;
